// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 3.46967C11.7626 3.17678 12.2375 3.17678 12.5304 3.46967L17.3033 8.24264C17.5962 8.53553 17.5962 9.01041 17.3033 9.3033C17.0104 9.59619 16.5356 9.59619 16.2427 9.3033L12.75 5.81066L12 5L11.25 5.81066L7.75738 9.3033C7.46449 9.59619 6.98961 9.59619 6.69672 9.3033C6.40383 9.01041 6.40383 8.53553 6.69672 8.24264L11.4697 3.46967Z"
				fill={props.color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 10.2197C11.7626 9.92678 12.2375 9.92678 12.5304 10.2197L17.3033 14.9926C17.5962 15.2855 17.5962 15.7604 17.3033 16.0533C17.0104 16.3462 16.5356 16.3462 16.2427 16.0533L12.75 12.5607V19V19.5361V20.5H11.25V12.5607L7.75738 16.0533C7.46449 16.3462 6.98961 16.3462 6.69672 16.0533C6.40383 15.7604 6.40383 15.2855 6.69672 14.9926L11.4697 10.2197Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
